import Button from './Button';
import LinkButton from './LinkButton';
import ExternalLink from './ExternalLink';

export const BUTTON = Button;
export const LINK = LinkButton;
export const EXTERNAL_LINK = ExternalLink;
export const MENULINK = Button;